/* eslint-disable no-unused-expressions */
import Api from "api/Api";
import Button from "components/button/Button";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { compose } from "redux";
import enhancer from "./enhancer";
import { ButtonGroup, Button as RButton } from "reactstrap";
import Toaster from "components/common/Toaster";
import Loader from "components/common/Loader";

const LoyaltyMangementForm = props => {
  const toaster = useRef(null);
  const {
    handleBlur,
    errors,
    touched,
    submitCount,
    values,
    setFieldValue,
    isStore,
    storeId,
    handleChange,
    setFieldTouched,
    setValues
  } = props;

  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [uploadImage, setUploadImage] = useState(null);
  const [noStampDisabled, setNoStampDisabled] = useState(false);

  useEffect(() => {
    if (isStore) {
      Api.post("/admin/loyalty/list", { storesId: storeId })
        .then(res => {
          if (res?.data?.status) {
            setValues({
              image: res?.data?.data?.stampImage,
              type: res?.data?.data?.loyaltyType || "NUMBER_OF_VISIT",
              stampNotification: res?.data?.data?.notificationForCardAdd,
              rewardNotification: res?.data?.data?.notificationForReward,
              requiredStamps: res?.data?.data?.requiredStamps,
              loyaltyStoreId: res?.data?.data?.loyaltyStoreId
            });
            setNoStampDisabled(!!res?.data?.data?.requiredStamps);
          }
          setTimeout(() => {
            setDataLoading(false);
          }, 500);
        })
        .catch(error => {
          if (toaster.current) toaster.current.error(error.message);
          setDataLoading(false);
        });
    }
  }, [isStore, storeId]);

  const Error = props => {
    const field1 = props.field;
    if (
      ((errors[field1] && touched[field1]) || submitCount > 0) &&
      !Array.isArray(errors[field1])
    ) {
      return (
        <span className={props.class ? props.class : "error-msg"}>
          {errors[field1]}
        </span>
      );
    } else {
      return <span></span>;
    }
  };

  const handleImage = (e, setValue) => {
    if (e.target.files[0]) {
      let fileObj = e.target.files[0];
      // setImageObj(fileObj);
      if (fileObj) {
        const img = new Image();

        img.src = window.URL.createObjectURL(fileObj);

        img.onload = function() {
          const width = img.naturalWidth,
            height = img.naturalHeight;

          window.URL.revokeObjectURL(img.src);
          setValue("width", width);
          setValue("height", height);
          setFieldTouched("image", true, true);

          setValue("image", URL.createObjectURL(fileObj));
          setValue("images", fileObj);
          setUploadImage(URL.createObjectURL(fileObj));
        };
      } else {
        //No file was input or browser doesn't support client side reading
        // form.submit();
      }
    } else {
      setUploadImage(null);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let { values, isValid, handleSubmit } = props;
    if (isValid) {
      const body = {
        loyaltyStoreId: values?.loyaltyStoreId,
        loyaltyType: values?.type,
        notificationForCardAdd: values?.stampNotification,
        notificationForReward: values?.rewardNotification,
        requiredStamps: values?.requiredStamps,
        storesId: storeId,
        existingImage: !values?.images ? values?.image : undefined
      };

      const formData = new FormData();
      for (let key in body) {
        if (body[key] !== undefined) formData.append(key, body[key]);
      }
      if (values?.images) formData.append("stampImage", values?.images);
      setLoading(true);
      Api.post("/admin/loyalty/add", formData)
        .then(res => {
          if (res.data.status) {
            if (toaster.current) toaster.current.success(res.data.message);
            setValues({
              image: res?.data?.data?.stampImage,
              type: res?.data?.data?.loyaltyType || "NUMBER_OF_VISIT",
              stampNotification: res?.data?.data?.notificationForCardAdd,
              rewardNotification: res?.data?.data?.notificationForReward,
              requiredStamps: res?.data?.data?.requiredStamps,
              loyaltyStoreId: res?.data?.data?.loyaltyStoreId,
              images: null
            });
            setNoStampDisabled(!!res?.data?.data?.requiredStamps);
          } else {
            if (toaster.current) toaster.current.error(res.data.message);
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          if (toaster.current) toaster.current.error(error.message);
        });
    }
    handleSubmit();
  };
  return (
    <div>
      {dataLoading ? (
        <Loader loading={dataLoading} />
      ) : (
        <form
          onSubmit={e => {
            handleSubmit(e);
          }}
        >
          <div className="form-group">
            <label className="fs-16 medium-text pr-12">
              Type <span className="asterisk">*</span>
            </label>
            <ButtonGroup disabled>
              <RButton
                color="secondary"
                outline
                onClick={() => setFieldValue("type", "NUMBER_OF_VISIT")}
                active={values?.type === "NUMBER_OF_VISIT"}
              >
                NUMBER OF VISIT
              </RButton>
              <RButton
                color="secondary"
                outline
                onClick={() => setFieldValue("type", "PERCENTAGE")}
                active={values?.type === "PERCENTAGE"}
                disabled
              >
                PERCENTAGE
              </RButton>
            </ButtonGroup>
          </div>

          <div className="form-group">
            <label className="fs-16 medium-text">
              Number of stamps <span className="asterisk">*</span>
            </label>
            <input
              type="number"
              className="form-control react-form-input"
              id="requiredStamps"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values?.requiredStamps}
              placeholder="Number of stamps"
              onKeyDown={e =>
                ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
              }
              disabled={noStampDisabled}
            />
            <Error field="requiredStamps" />
          </div>

          <div className="form-group">
            <label className="fs-16 medium-text">
              Notification for Stamp<span className="asterisk">*</span>
            </label>
            <textarea
              id="stampNotification"
              style={{ resize: "none" }}
              type="text"
              rows={2}
              placeholder="Number of stamps"
              className="form-control react-form-input"
              value={values.stampNotification}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Error field="stampNotification" />
          </div>

          <div className="form-group">
            <label className="fs-16 medium-text">
              Notification for Reward<span className="asterisk">*</span>
            </label>
            <textarea
              id="rewardNotification"
              style={{ resize: "none" }}
              type="text"
              placeholder="Notification for Reward"
              rows={2}
              className="form-control react-form-input"
              value={values.rewardNotification}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            <Error field="rewardNotification" />
          </div>

          <div className="form-group">
            <label className="fs-16 medium-text">
              Card <span className="asterisk">*</span>
            </label>
            <div className="file-upload">
              <label className="c-btn c-secondary  form-button fs-16 demi-bold-text mt-15">
                Upload Image
                <input
                  id="image"
                  className="file-upload__input"
                  name="file-upload"
                  type="file"
                  style={{ display: "none" }}
                  accept="image/jpg,image/png,image/jpeg"
                  onChange={e => handleImage(e, setFieldValue)}
                  onBlur={handleBlur}
                />
              </label>
            </div>
            {(uploadImage || values.image) && (
              <img
                src={uploadImage ? uploadImage : values.image}
                alt=""
                className="mtb-15"
                style={{
                  width: "200px",
                  borderRadius: "4%",
                  height: "150px",
                  background: "#404040"
                }}
              />
            )}
            <Error field="image" />
          </div>

          <Button
            type="submit"
            loading={loading}
            disabled={loading}
            className="c-btn c-info form-button fs-16 demi-bold-text mr-15"
            style={{ maxWidth: "125px" }}
            dataStyle="expand-right"
          >
            Submit
          </Button>
        </form>
      )}
      <Toaster ref={toaster} />
    </div>
  );
};

export default compose(enhancer)(LoyaltyMangementForm);
